import {ExternalLinksLegacyStrategy} from "./external-links-legacy.strategy";
import {MarketingParams} from "../../../../common/interfaces/marketing-params.interface";
import {IExternalLinksHandlersFactory} from "../handlers-factory/external-links-handlers-factory.interface";
import {IOpenMyAccountOptions} from "../handlers/my-account/my-account.external-link-handler.interface";

const UseModernStrategy = {
    forMyAccount: true
}

export class ExternalLinksModernStrategy extends ExternalLinksLegacyStrategy {

    private get _handlers(): IExternalLinksHandlersFactory {
        return this.services.regulation.current.externalLinks;
    }


    openMyAccount(options?: IOpenMyAccountOptions, marketingParams?: MarketingParams): Promise<void> {
        if(UseModernStrategy.forMyAccount) {
            return this._handlers.myAccount.openMyAccount(options);
        }

        return super.openMyAccount(options);
    }


}